import Cookies from 'js-cookie';

import '../scss/app.scss';

import './shop';
import './accordion';
import './tabs';
import './vertical-tabs';

const $ = jQuery;

$(document).ready(function($) {
	$('.menu-item a').click(function (e) {
		if ($(this).attr('href') === '#') {
			e.preventDefault();
		}
	});

	$('a[href*="#"]').click(function (e) {
		const hash = $(this).attr('href').split('#')[1];
		const el = $('#' + hash);
		if (el.length > 0) {
			e.preventDefault();
			window.scroll({
				top: $(el).offset().top,
				left: 0,
				behavior: 'smooth',
			});
		}
	});

	// Photo Galleries grid
	$('.photo-grid').imagesLoaded(function () {
		$('.photo-grid').isotope({
			itemSelector: '.photo-grid-item',
			percentPosition: true,
			masonry: {
				gutter: 9,
				columnWidth: '.grid-sizer',
			},
		});
	});

	$('.photo-grid').lightGallery({
		download: false,
		index: $(this).data('photo-id') || 0,
	});

	// Initialize FitVids
	$('iframe[src*="youtube"],iframe[src*="youtu.be"],iframe[src*="vimeo"]').parent().fitVids({ maxWidth: 1024 });

	// Open modal
	$('a.flm').featherlight({
		targetAtr: 'href',
	});

	// Open contact team member modal
	$('a.flc').featherlight({
		targetAtr: 'href',
		persist: 'shared',
		beforeOpen: function(e) {
			var container = $(e.target).closest('.team-member');
			$('#contact-team-member .contact-team-member-name').html(container.find('.team-member-name').html());
			$('#contact-team-member .contact-team-member-position').html(container.find('.team-member-role').html());
			$('#contact-team-member .gfield.hidden-recipient-name input').val(container.find('.team-member-name').html());
			$('#contact-team-member .contact-team-member-photo > img').attr('src', container.find('.team-member-modal-image > img').attr('src'));
		},
	});

	// WP galleries
	$('.gallery-item a').featherlightGallery({
		variant: 'nf-gallery',
	});

	// Add captions to gallery images in modal
	$.featherlightGallery.prototype.beforeContent = function() {
		var caption = this.$currentTarget.find('img').attr('alt');
		this.$instance.find('.caption').remove();
		$('<div class="caption">').text(caption).appendTo(this.$instance.find('.featherlight-content'));
	};

	$('a[href*="in_iframe=true"]').featherlight({
		targetAttr: 'href',
	});

	if (!Cookies.get('nf-newsletter')) {
		setTimeout(function() {
			$.featherlight($('#newsletter-form-modal'), {
				persist: true,
				variant: 'newsletter-modal-wrapper',
				openSpeed: 200,
				closeSpeed: 400,
				afterOpen: function() {
					$('html').removeClass('with-featherlight');
					$('#newsletter-form-modal').parent().css('left', $(window).innerWidth());
					$('#newsletter-form-modal').parent().animate({
						left: 0,
					}, 500);
				},
				beforeClose: function() {
					$('#newsletter-form-modal').parent().animate({
						left: $(window).innerWidth(),
					}, 500);
				},
			});
			Cookies.set('nf-newsletter', true, { expires: 30 });
		}, 5000);
	}

	$('.featured-slider').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: true,
		fade: true,
		asNavFor: '.featured-slider-navigation',
		responsive: [
			{
				breakpoint: 768,
				settings: {
					arrows: false,
					dots: true,
				}
			},
		],
	});

	$('.featured-slider-navigation').slick({
		slidesToShow: 3,
		slidesToScroll: 1,
		asNavFor: '.featured-slider',
		dots: false,
		focusOnSelect: true,
	});

    $('.instagram-slider').slick({
		centerMode: true,
		centerPadding: '120px',
		infinite: true,
		slidesToShow: 6,
		slidesToScroll: 6,
		responsive: [
			{
				breakpoint: 1280,
				settings: {
					centerPadding: '100px',
					slidesToShow: 5,
					slidesToScroll: 5,
				}
			},
			{
				breakpoint: 1024,
				settings: {
					centerPadding: '80px',
					slidesToShow: 4,
					slidesToScroll: 4,
				}
			},
			{
				breakpoint: 768,
				settings: {
					centerPadding: '60px',
					slidesToShow: 3,
					slidesToScroll: 3,
				}
			},
			{
				breakpoint: 500,
				settings: {
					centerMode: false,
					slidesToShow: 2,
					slidesToScroll: 2,
				}
			},
			{
				breakpoint: 300,
				settings: {
					centerMode: false,
					slidesToShow: 1,
					slidesToScroll: 1,
				}
			},
		],
	});

	$('.blog-featured-slider').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
	});
});

// Navigation
$(document).ready(function() {
	var menuToggle = $('#js-mobile-menu').unbind();
	$('#js-navigation-menu').removeClass('show');

  	menuToggle.on('click', function(e) {
    	e.preventDefault();
    	$('#js-navigation-menu').slideToggle(function() {
      		if ($('#js-navigation-menu').is(':hidden')) {
        		$('#js-navigation-menu').removeAttr('style');
      		}
    	});
  });
});

// Sliding panel
$(document).ready(function() {
	$('.sliding-panel-button, .sliding-panel-fade-screen, .sliding-panel-close').on('click touchstart', function(e) {
		e.preventDefault();
		$('.sliding-panel-content, .sliding-panel-fade-screen').toggleClass('is-visible');
  	});
});



// WEBPACK FOOTER //
// ./src/js/app.js